import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import VulnMethodSupportStatus from '~/utils/VulnMethodSupportStatus';
import * as artifactActions from '~/artifact/actions';
type ArtifactViewMainContentSignaturesComponentVersionDetailsVulnerableMethodsProps = {
  actions: object;
  artifactState: object;
};
class ArtifactViewMainContentSignaturesComponentVersionDetailsVulnerableMethods extends React.Component<
  ArtifactViewMainContentSignaturesComponentVersionDetailsVulnerableMethodsProps,
  {}
> {
  componentDidMount() {
    let store = this.props.artifactState || {},
      artifact = store.viewMode === 'VIEW' ? store.artifact || {} : store.editedArtifact || {},
      currentComponentId = store.componentId,
      vulnerableMethods = store.vulnerableMethods,
      version = store.activeVulnerableVersion;
    if (!vulnerableMethods && version) {
      this.props.actions.fetchVulnerableMethods(artifact, currentComponentId, version);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    let oldVersion = this.props.artifactState.activeVulnerableVersion,
      newVersion = nextProps.artifactState.activeVulnerableVersion,
      store = nextProps.artifactState,
      artifact = store.viewMode === 'VIEW' ? store.artifact || {} : store.editedArtifact || {},
      currentComponentId = store.componentId;
    if (newVersion && newVersion !== oldVersion) {
      this.props.actions.fetchVulnerableMethods(artifact, currentComponentId, newVersion);
    }
  }
  render() {
    let store = this.props.artifactState,
      vulnerableMethods = store.vulnerableMethods || [],
      methodElements = [],
      bodyElement,
      vulnMethodCount = 0,
      currentComponentId = store.componentId,
      affectedComponents = store.affectedComponents,
      currentComponent =
        _.find(affectedComponents, comp => {
          return comp.id === currentComponentId;
        }) || {},
      languageType = currentComponent.languageType || '',
      language = languageType.toLowerCase() || '',
      niceLanguage = language,
      moduleHtml,
      signatureHtml;
    if (language === 'js') {
      niceLanguage = 'JavaScript';
    } else if (language === 'ruby') {
      niceLanguage = 'Ruby';
    } else if (language === 'python') {
      niceLanguage = 'Python';
    }

    // When VM is not supported by language, show coming soon
    // Otherwise, handle display of VM list.
    if (!VulnMethodSupportStatus.isLanguageSupported(language)) {
      bodyElement = (
        <div className="grid pt- ph">
          <div className="grid__item col-1-1 font--h7 pt">
            Vulnerable methods for {niceLanguage} coming soon.
          </div>
        </div>
      );
    } else {
      if (vulnerableMethods.length) {
        vulnerableMethods.forEach((vulnerableMethod, i) => {
          vulnMethodCount += vulnerableMethod.callChains.length;
          const method = vulnerableMethod.method;
          if (language === 'python' || language === 'go') {
            moduleHtml = (              
              <div className="grid pt-- pb--">
                <div className="grid__item pl0 col-1-8 pt--">Module</div>
                <div className="grid__item col-7-8 word-wrap">
                  <span className="font-family--code col-1-1 bg-color--white p-- inline-block border-color--white-light p-- bo--1 bo-rad--3">
                    <span className="word-wrap font--11">{method.moduleName}</span>
                  </span>
                </div>
              </div>
            );
          }
          if (language !== 'go') {
            signatureHtml = (
              <div className="grid pt-- pb--">
                <div className="grid__item pl0 col-1-8 pt--">Signature</div>
                <div className="grid__item col-7-8">
                  <span className="font-family--code col-1-1 bg-color--white p-- inline-block border-color--white-light p-- bo--1 bo-rad--3">
                    <span className="word-wrap font--11">{method.descriptor}</span>
                  </span>
                </div>
              </div>
            );
          }
          methodElements.push(
            <div
              key={`${method.className}-${i}`}
              className="grid bo-l--2 ph- pv-- position--relative border-color--muted-light max-width--500"
            >
              <div className="grid__item col-1-1">
                <div className="grid bg-color--white-light border-color--white-dark bo--1 bo-rad--3 p--">
                  <div className="grid__item col-1-1">
                    {moduleHtml}
                    <div className={'grid grid—middle pb-- pt--'}>
                      <div className="grid__item pl0 col-1-8 pt--">{language === 'go' ? 'Path' : 'Class'}</div>
                      <div className="grid__item col-7-8 word-wrap">
                        <span className="font-family--code col-1-1 bg-color--white p-- inline-block border-color--white-light p-- bo--1 bo-rad--3">
                          <span className="word-wrap font--11 ">{method.className}</span>
                        </span>
                      </div>
                    </div>
                    <div className="grid grid--middle pt-- pb--">
                      <div className="grid__item pl0 col-1-8 pt--">{language === 'go' ? 'Symbol' : 'Method'}</div>
                      <div className="grid__item col-7-8 word-wrap">
                        <span className="font-family--code col-1-1 bg-color--white p-- inline-block border-color--white-light p-- bo--1 bo-rad--3">
                          <span className="word-wrap font--11 ">{method.methodName}</span>
                        </span>
                      </div>
                    </div>
                    {signatureHtml}
                  </div>
                  <i className="bg-color--muted-dark top--15 width--6 height--6 bo-rad--3 bo--2 border-color--muted-light left--neg-4 position--absolute block font--10" />
                </div>
              </div>
            </div>
          );
        });
        bodyElement = (
          <div className="grid ph">
            <div className="grid__item col-1-1 border-color--muted p0">
              Vulnerable methods are used by agents to determine if your code actually uses the
              vulnerable parts of a vulnerable library. The agent builds a call graph for your
              project and then determines if the call graph uses a call chain in the vulnerable
              library.
            </div>
            <div className="bo-b--2 width--200 border-color--white-dark mv-" />
            <div className="">
              We calculated {vulnMethodCount} call chains from {vulnerableMethods.length} vulnerable
              methods below.
            </div>
            <div className="grid__item col-1-1 mt">{methodElements}</div>
          </div>
        );
      } else {
        bodyElement = (
          <div className="grid pt- ph">
            <div className="grid__item col-1-1 font--h7 pt">
              No vulnerable methods for {currentComponent.name}@{store.activeVulnerableVersion}{' '}
              detected.
            </div>
          </div>
        );
      }
    }

    return <div> {bodyElement} </div>;
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentSignaturesComponentVersionDetailsVulnerableMethods);
